module.exports = __webpack_public_path__ + "resources/img/img_mazebolt1_m.cb3dff27067b7ea249776f205b443215.png";